export const BuildInfo = {timestamp:1773088997000}
